// material
import { experimentalStyled as styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
//
// import Logo from './Logo';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme?.palette?.background.default || '#fff',
}));

// ----------------------------------------------------------------------

export default function LoadingScreen({ ...other }) {
  return (
    <RootStyle data-testid={'loading-screen'} {...other}>
      <Box sx={{ width: 70 }} align="center">
        <CircularProgress size={70} />
      </Box>
    </RootStyle>
  );
}
